import { useMemo } from 'react'

import { useFetch } from '#hooks/useAdminResource'

interface CarrierOptionResponse {
  scac: string
  name: string
}

const ALL_CARRIERS_OPTION = {
  value: '',
  label: 'All carriers',
}

export const useCarrierOptions = () => {
  const { data, isLoading, error } = useFetch<CarrierOptionResponse[]>(
    'carriers',
    {},
  )

  const options = useMemo(() => {
    const carrierOptions = (data ?? []).map(carrier => ({
      value: carrier.scac,
      label: `${carrier.scac.toUpperCase()} - ${carrier.name}`,
    }))

    return [ALL_CARRIERS_OPTION, ...carrierOptions]
  }, [data])

  return {
    options,
    isLoading,
    error: error?.message,
  }
}
